
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"10","viewBox":"0 0 14 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.336.333H5c-1.225 0-2.39.492-3.283 1.384C.825 2.61.333 3.775.333 5s.492 2.39 1.384 3.283C2.61 9.175 3.775 9.667 5 9.667h5.333V8.333H5c-.869 0-1.7-.352-2.34-.993A3.299 3.299 0 011.667 5c0-.868.352-1.7.993-2.34A3.299 3.299 0 015 1.667h5.333V1l.001.667h.002c.527 0 1.026.209 1.406.59a1.977 1.977 0 01.002 2.817 1.992 1.992 0 01-1.41.593H5a.66.66 0 01-.465-.2A.66.66 0 014.333 5c0-.168.074-.338.201-.465A.658.658 0 015 4.333h5.333V3H5c-.527 0-1.027.21-1.41.593C3.21 3.973 3 4.473 3 5c0 .526.21 1.027.592 1.41.381.38.882.59 1.408.59h5.334c.883 0 1.718-.349 2.352-.982a3.311 3.311 0 000-4.703 3.3 3.3 0 00-2.35-.982z","fill":"#7E8186"}})])
          )
        }
      }
    